import { useState } from "react";
import assets from "../../assets";
import "./styles.sass";
import { ADMIN_NAV_ICONS } from "../../utils/constant";
import { useNavigate, useLocation } from "react-router-dom";
import {
  COOKIE_ACCESS_MAIL,
  COOKIE_ACCESS_ROLE,
} from "../../utils/storage-constants";
import { useSingleton } from "../../hooks/use-singleton";
import { useAuth } from "../../hooks/use-auth";
import { LogoutPopup } from "../logout-popup";

export const AdminBaseContainer = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const { updateMail, updateRole, user, mail, role } = useSingleton();

  const renderNavItems = (item, index) => {
    const { activeIcon, icon, route, label } = item || {};
    const isActive = route && location.pathname === route;
    const showIcon = isActive && activeIcon ? activeIcon : icon;
    return (
      <section
        className={`nav_wrapper${isActive ? " active" : ""}`}
        key={index}
        data-tooltip={label}
        onClick={() => route && navigate(route)}
      >
        <img src={icon} alt="i" />
        <span className="nav_label">{label}</span>
      </section>
    );
  };

  const { logout } = useAuth();
  const logoutHandler = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <section className="base_container">
      {/* nav wrapper */}
      <section
        className={`nav_container${isExpanded ? " expanded" : ""}`}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <section className="nav_top_section">
          <img src={assets.ic_nav_logo} alt="ic_nav_logo" />
          {ADMIN_NAV_ICONS.map(renderNavItems)}
        </section>
        <section className="nav_bottom_section">
          <section className="nav_wrapper bottom_item" data-tooltip="Profile">
            <img
              src={assets.ic_chat_person}
              className="profile_icon"
              alt="profile"
            />
            <section className="profile_meta">
              <span className="profile_name">
                {user?.data?.name || mail || "Profile"}
              </span>
              {role && <span className="profile_role">{role}</span>}
            </section>
          </section>
          <section
            className="nav_wrapper bottom_item"
            data-tooltip="Logout"
            onClick={() => setShow(true)}
          >
            <img src={assets.ic_logout} className="logout_icon" alt="logout" />
            <span className="nav_label">Logout</span>
          </section>
        </section>
      </section>
      {/* <section className="nav_context_contanier">
             <section className="nav_learn_title">
                 <h4>Learning Context</h4>
                 <h6>Set your topic to start learning</h6>
             </section>
             <section className="nav_subject_details">
                 <section className="board_wrapper">
                     <section className="board">
                         <h5>Board</h5>
                         <h4>CBSE</h4>
                    </section> 
                     <section className="class">
                        <h5>Board</h5>
                         <h4>CBSE</h4>
                    </section> 
                 </section>
             </section>
             <section className="nav_subject_wrapper">
                 <section className="subject_wrapper"  onClick={() => setOpenDropdown("subject")}>
                     <h4>Subject</h4>
                     <section className="drop_down_wrapper">
                         <p>{selectedSubject || "Select Subject"}</p>
                         <img src={assets.ic_chevron_down} alt="chevron" />
                     </section>
                        {openDropdown === "subject" && (
                            <section className="options_list">
                            {SUBJECT_OPTIONS?.map((item, i) => (
                                <p
                                key={i}
                                className="option_item"
                                onClick={() => {
                                    setSelectedSubject(item);
                                    setOpenDropdown(null);
                                }}
                                >
                                {item}
                                </p>
                            ))}
                            </section>
                        )}
                  </section>
                 <section className="subject_wrapper" onClick={() => setOpenDropdown("chapter")}>
                     <h4>Chapter</h4>
                     <section className="drop_down_wrapper">
                           <p>{selectedChapter || "Select Chapter"}</p>
                         <img src={assets.ic_chevron_down} alt="chevron" />
                     </section>
                       {openDropdown === "chapter" && (
                            <section className="options_list">
                            {CHAPTER_OPTIONS?.map((item, i) => (
                                <p
                                key={i}
                                className="option_item"
                                onClick={() => {
                                    setSelectedChapter(item);
                                    setOpenDropdown(null);
                                }}
                                >
                                {item}
                                </p>
                            ))}
                            </section>
                        )}
                 </section>
                 <section className="subject_wrapper">
                     <h4>Language</h4>
                     <section className="drop_down_wrapper" onClick={() => setOpenDropdown("language")}>
                         <p>{selectedLanguage || "Select Language"}</p>
                         <img src={assets.ic_chevron_down} alt="chevron" />
                     </section>
                       {openDropdown === "language" && (
                            <section className="options_list">
                            {LANGUAGE_OPTIONS?.map((item, i) => (
                                <p
                                key={i}
                                className="option_item"
                                onClick={() => {
                                    setSelectedLanguage(item);
                                    setOpenDropdown(null);
                                }}
                                >
                                {item}
                                </p>
                            ))}
                            </section>
                        )}
                 </section>
             </section>
         </section> */}
      <section className="child_wrapper">{children}</section>
      {show && (
        <LogoutPopup
          title="Logout"
          description="Are you sure you want to logout from your account?"
          btnText="Logout"
          onClose={() => setShow(!show)}
          onLogout={logoutHandler}
        />
      )}
    </section>
  );
};
